import { Flex, Heading, View, Image, Text, Button, Dialog, Content, Divider, ButtonGroup } from '@adobe/react-spectrum';
import styles from '../../../../styles.module.scss';
import { FC, useRef } from 'react';
import { useMainContainerProvider } from '../../../../mainContainerProvider';
import { capitalizeWords } from '../../../../util';
import PersonalDetails from './personalDetails';
import { AddOnType, StudentPaymentData } from '../../types';
import SummarySection from './summarySection';
import { PaymentMethodEnum, FeesStatus } from '../constant';
import LabeledValue from '../../../../CommonComponent/labeledValue';
import { printPaymentSummary } from '../../utils';

const PaymentSummaryPreview: FC<{
  setOpenPreviewDialog: React.Dispatch<React.SetStateAction<boolean>>;
  studentData: StudentPaymentData;
  finalCostComponent: AddOnType[];
  transactionNumber: string;
  selectedMethod: string;
}> = ({ setOpenPreviewDialog, studentData, finalCostComponent, transactionNumber, selectedMethod }) => {
  const printRef = useRef<HTMLDivElement>(null);
  const { instituteLogo, instituteAddress, instituteName, instituteEmail, instituteContact, instituteWebsite } = useMainContainerProvider();

  const handleSubmit = () => {
    printPaymentSummary({
      studentData,
      finalCostComponent,
      transactionNumber,
      selectedMethod,
      instituteData: {
        logo: instituteLogo,
        name: instituteName,
        address: instituteAddress,
        email: instituteEmail,
        contact: instituteContact,
        website: instituteWebsite,
      },
    });
  };
  return (
    <Dialog>
      <Heading>Payment Summary</Heading>
      <Divider />
      <Content>
        <View width="100%" UNSAFE_className={styles.card}>
          <Flex direction="column" gap="size-200" width="100%" alignItems="center">
            <div ref={printRef} className={styles.printable}>
              <Flex width="100%" gap="size-100" justifyContent="center" alignItems="center" direction="column">
                <Image
                  UNSAFE_style={{ borderRadius: '50%' }}
                  width="8%"
                  height="8%"
                  src={instituteLogo ? instituteLogo : '/images/dummyImage.png'}
                  alt="School Logo"
                />
                <Flex direction="column" justifyContent="center" alignItems="center">
                  {instituteName !== 'undefined' && instituteName !== 'null' && instituteName && (
                    <Text UNSAFE_style={{ fontSize: '150%', fontWeight: 'bold' }}>{capitalizeWords(instituteName)}</Text>
                  )}
                  {instituteAddress !== 'undefined' && instituteAddress !== 'null' && instituteAddress && (
                    <Text UNSAFE_style={{ fontSize: '100%', fontWeight: 'bold' }}>{instituteAddress}</Text>
                  )}
                  <Flex>
                    {instituteEmail !== 'undefined' && instituteEmail !== 'null' && instituteEmail && (
                      <Text UNSAFE_style={{ fontSize: '80%', fontWeight: 'bold' }}>Email: {instituteEmail}</Text>
                    )}
                    {instituteContact !== 'undefined' && instituteContact !== 'null' && instituteContact && (
                      <Text UNSAFE_style={{ fontSize: '80%', fontWeight: 'bold' }}>, Contact: {instituteContact}</Text>
                    )}
                    {instituteWebsite !== 'undefined' && instituteWebsite !== 'null' && instituteWebsite && (
                      <Text UNSAFE_style={{ fontSize: '80%', fontWeight: 'bold' }}>, Website: {instituteWebsite}</Text>
                    )}
                  </Flex>
                </Flex>
              </Flex>
              <PersonalDetails studentData={studentData} />
              <Flex
                direction="row"
                wrap="wrap"
                marginTop="size-200"
                rowGap="size-200"
                marginBottom="size-200"
                UNSAFE_style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                }}
              >
                <LabeledValue width="25%" label="Payment Method" value={selectedMethod === PaymentMethodEnum.ONLINE ? 'Online' : 'Cash'} textAlign="center" />
                {selectedMethod === PaymentMethodEnum.ONLINE && (
                  <LabeledValue width="25%" label="Transaction Number" value={transactionNumber} textAlign="center" />
                )}
                <LabeledValue
                  width="25%"
                  label="Payment Date"
                  value={`${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`}
                  textAlign="center"
                />
                <LabeledValue
                  width="25%"
                  label="Fees Paid Month(s)"
                  value={studentData.feesDetails
                    .filter((item) => item.feesStatus === FeesStatus.INPROCESS)
                    .map((item) => item.month)
                    .join(', ')}
                  textAlign="center"
                />
              </Flex>
              <SummarySection finalCostComponent={finalCostComponent} />
            </div>

            <Button width="size-2000" variant="accent" onPress={() => handleSubmit()}>
              Submit
            </Button>
          </Flex>
        </View>
      </Content>
      <ButtonGroup>
        <Button variant={'primary'} onPress={() => setOpenPreviewDialog(false)}>
          Close
        </Button>
      </ButtonGroup>
    </Dialog>
  );
};

export default PaymentSummaryPreview;
